import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import Menu from './components/Navbar';
import Home from './components/views/Home';
import NotFound from './components/views/NotFound';
import './App.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const theme = createTheme();
class  App extends Component {
  render(){
    const { match } = this.props;
    return (
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <CssBaseline />
            <div className="App">
              <Menu />
              <Switch>
                <Route exact path={`${match.path}`} component={Home}/>
                <Route component={NotFound}/>
              </Switch>
            </div>
          </LocalizationProvider>
        </ThemeProvider>
    );
  }
}

export default App;
